import React from 'react';

const CaveIcon = (props) => {
  return (
    <img
      alt="Jaskinia"
      src="/static/images/icons/place_types/cave.svg"
      {...props}
    />
  );
};

export default CaveIcon;
